<mat-form-field>
  <mat-label
    [class.filled-multi-select-float-label]="isMultiSelect && ngControl.value"
    [class.empty-multi-select-float-label]="isMultiSelect && !ngControl.value?.length"
  >
    {{ (label | translate) + isFieldRequired(ngControl.control) }}
    <ng-container *ngIf="tooltipText">
      <ui-svg-icon
        [name]="iconNames.QuestionFrame"
        [matTooltip]="tooltipText | translate"
        class="help-icon__with-height tw-align-middle"
      ></ui-svg-icon>
    </ng-container>
  </mat-label>

  <ng-container *ngIf="!isMultiSelect">
    <mat-chip-grid #chipList [formControl]="ngControl.control" [errorStateMatcher]="errorMatcher">
      <mat-chip-row
        *ngIf="chipControl.value"
        [attr.test-id]="chipControl.value[searchValueKey] || chipControl.value"
        [removable]="isChipRemovable"
        (removed)="removeChipItem(chipControl.value)"
        [matTooltip]="singleSelectionTooltipText"
      >
        {{ chipControl.value | valueMask : selectedValueMask }}
        <ui-svg-icon *ngIf="isChipRemovable" [name]="iconNames.Close" [width]="18" matChipRemove></ui-svg-icon>
      </mat-chip-row>
      <input
        matInput
        #chipInput
        [formControl]="searchControl"
        [attr.test-id]="testId"
        [matAutocomplete]="autocomplete"
        [errorStateMatcher]="errorMatcher"
        [matChipInputAddOnBlur]="!autocomplete.isOpen"
        (blur)="onBlur()"
        [matChipInputFor]="chipList"
      />
    </mat-chip-grid>
  </ng-container>

  <ng-container *ngIf="isMultiSelect">
    <mat-chip-grid #chipList [formControl]="chipsControl" [errorStateMatcher]="errorMatcher">
      <mat-chip-row
        *ngFor="let item of chipsControl.value"
        [attr.test-id]="item.name || item"
        [removable]="isChipRemovable"
        [value]="item"
        (removed)="removeChipItem(item)"
      >
        <ng-container *ngTemplateOutlet="chipItemTemplate; context: { $implicit: item }"></ng-container>
        <ui-svg-icon *ngIf="isChipRemovable" [name]="iconNames.Close" [width]="18" matChipRemove></ui-svg-icon>
      </mat-chip-row>

      <input
        matInput
        #chipInput
        [formControl]="searchControl"
        [errorStateMatcher]="errorMatcher"
        [attr.test-id]="testId"
        [matAutocomplete]="autocomplete"
        [matChipInputFor]="chipList"
        [matChipInputAddOnBlur]="!autocomplete.isOpen"
        (blur)="onBlur()"
      />
    </mat-chip-grid>
  </ng-container>

  <mat-autocomplete
    #autocomplete="matAutocomplete"
    (optionSelected)="isMultiSelect ? onOptionSelectedForChipList($event) : onOptionSelected($event)"
  >
    <mat-option *ngFor="let item of autocompleteList" [value]="item" [attr.test-id]="item[searchValueKey] || item">
      <ng-container *ngTemplateOutlet="autocompleteItemTemplate; context: { $implicit: item }"></ng-container>
    </mat-option>
    <div *ngIf="isLoadMoreEnabled" class="load-more">
      <span class="link" (click)="onLoadMore()">
        <ui-svg-icon [name]="iconNames.Refresh" class="tw-align-middle"></ui-svg-icon>
        {{ 'monitoring.uli.create.uliInfo.loadMoreAddress' | translate : { amount: loadMoreAmount } }}
      </span>
    </div>
  </mat-autocomplete>
  <mat-error *ngIf="ngControl.control.invalid && (ngControl.control.touched || ngControl.control.dirty)">
    <ui-field-error-messages [control]="ngControl.control"></ui-field-error-messages>
  </mat-error>
</mat-form-field>
